import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IGetAuthFederationAdminResponse } from '../service/AuthFederationService';

export function getAuthFederationAdminRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'GET',
    endpoint: 'auth-federation/admin',
    serverWideRequest: false
  };
}

export function callGetAuthFederationAdminRequest(): Promise<IGetAuthFederationAdminResponse> {
  return makeJsonRestApiRequest<null, IGetAuthFederationAdminResponse>({
    config: getAuthFederationAdminRequestConfig(),
    request: null
  });
}
